import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-painel-status-terminal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './painel-status-terminal.component.html',
  styleUrls: ['./painel-status-terminal.component.css']
})
export class PainelStatusTerminalComponent {
  @Input() online = true;
  @Input() cacheBiometricoValido = false;
  @Input() totalFuncionariosCache = 0;
  @Input() ultimaConexaoOnline: Date | null = null;
  @Input() registrosPendentesOffline = 0;
  @Input() sincronizandoOffline = false;
  @Input() terminalAutorizado = false;
  @Input() terminalToken = '';

  @Output() alternarFilaOffline = new EventEmitter<void>();
}
